import { r as registerInstance, h, H as Host } from './index-16dc7dde.js';

const smartEllipsis = (container, content, label) => {
  container.innerHTML = content;
  const containerRect = container.getBoundingClientRect();
  const maxHeight = containerRect.height;
  const dFragment = getSplitText(container, maxHeight);
  container.textContent = '';
  container.appendChild(dFragment);
  const { length } = container.childNodes;
  const truncatedText = document.createElement('div');
  truncatedText.classList.add('truncated-text');
  truncatedText.appendChild(container.childNodes[length - 1]);
  if (label) {
    const languageLabel = document.createElement('span');
    languageLabel.classList.add('label');
    languageLabel.textContent = label;
    truncatedText.appendChild(languageLabel);
  }
  container.appendChild(truncatedText);
};
const getSplitText = (div, maxHeight) => {
  const range = document.createRange();
  const dFragment = document.createDocumentFragment();
  const lineHeight = Math.max(0, parseFloat(getComputedStyle(div).lineHeight));
  const text = div.textContent.trim();
  div.firstChild.textContent = div.firstChild.textContent.trim();
  const node = div.firstChild;
  let lastHeight = 0;
  let indexStart = 0;
  let txtOffset = 0;
  range.setStart(node, 0);
  maxHeight += range.getBoundingClientRect().height - lineHeight;
  for (; txtOffset < text.length; txtOffset += 1) {
    range.setEnd(node, txtOffset);
    const curHeight = Math.round(range.getBoundingClientRect().height);
    if (curHeight !== lastHeight) {
      if (lastHeight) {
        const span = document.createElement('span');
        span.textContent = curHeight > maxHeight
          ? text.substring(indexStart)
          : text.substring(indexStart, txtOffset - 1);
        span.classList.add('smart-ellipsis__row');
        dFragment.appendChild(span);
        if (curHeight > maxHeight) {
          indexStart = -1;
          break;
        }
      }
      indexStart = txtOffset - 1;
      lastHeight = curHeight;
    }
  }
  if (indexStart !== -1 || txtOffset === text.length) {
    const span = document.createElement('span');
    span.textContent = text.substring(indexStart);
    span.classList.add('smart-ellipsis__row');
    dFragment.appendChild(span);
  }
  return dFragment;
};

const pesSmartEllipsisCss = ".pes-smart-ellipsis{height:100%;display:block}.pes-smart-ellipsis .smart-ellipsis__row{display:block;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.pes-smart-ellipsis .truncated-text{display:flex;align-items:center}.pes-smart-ellipsis .label{font-size:12px;line-height:20px;display:inline;height:20px;padding:0 5px;font-weight:normal;color:#626469;background-color:rgba(98, 100, 105, 0.1);text-transform:capitalize;margin:0 5px;border-radius:2px}";

let SmartEllipsis = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.update = () => {
      setTimeout(() => {
        smartEllipsis(this.ref, this.content, this.label);
      });
    };
  }
  componentDidLoad() {
    window.addEventListener('resize', this.update);
    this.update();
  }
  componentDidUpdate() {
    this.update();
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.update);
  }
  render() {
    return (h(Host, null, h("div", { ref: (el) => (this.ref = el), class: `pes-smart-ellipsis pes-smart-ellipsis-${this.modifier}`, style: { maxHeight: this.maxHeight } })));
  }
};
SmartEllipsis.style = pesSmartEllipsisCss;

export { SmartEllipsis as pes_smart_ellipsis };
